const base = () => {
  return {
    author: "ImACoderImACoderImACoder",
    borderStyle: "solid",
    borderColor: "darkgray",
    buttonColorMain: "black",
    currentTemperatureColor: "antiquewhite",
    targetTemperatureColor: "antiquewhite",
    buttonActive: {
      color: "white",
      backgroundColor: "darkgray",
      borderColor: "antiquewhite",
    },
    backgroundColor: "black",
    primaryFontColor: "antiquewhite",
    iconColor: "rebeccapurple",
    iconTextColor: "rebeccapurple",
    plusMinusButtons: {
      backgroundColor: "black",
      color: "inherit",
      borderColor: "inherit",
    },
    temperatureRange: {
      lowTemperatureColor: "#f53803",
      highTemperatureColor: "#f5d020",
      background: "linear-gradient(315deg, #f53803 0%, #f5d020 74%)",
      rangeBoxColor: "black",
      rangeBoxBorderColor: "orange",
      rangeBackground: undefined,
      rangeBoxBorderRadius: "0.25rem",
      rangeBoxBorderWidth: "3px",
    },
    workflowEditor: {
      accordianExpandedColor: "#D2D2D2",
    },
    ToggleButtons: {
      sliderBackgroundColorOn: "gray",
      sliderBackgroundColorOff: undefined,
      sliderBorderColorOn: "#f8f9fa",
      sliderBorderColorOff: "#f8f9fa",
      onBackgroundColor: "#198754",
      onBorderColor: "#198754",
      onColor: "#fff",
      offBackgroundColor: "#dc3545",
      offBorderColor: "#dc3545",
      offColor: "#fff",
      backgroundImageOn: undefined,
      backgroundImageOff: undefined,
      backgroundBlendModeOn: "unset",
      backgroundBlendModeOff: "unset",
    },
  };
};

export default base;
